var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38100_2871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.3857C0.0653933 18.8178 0.122438 18.2492 0.198267 17.6826C0.269225 17.1541 0.285922 17.1485 0.781936 17.266C5.31564 18.3428 9.85003 19.4202 14.3837 20.4984C14.8679 20.6131 14.8679 20.6152 14.7058 21.0966C13.192 25.5795 11.6755 30.061 10.1693 34.5468C10.0733 34.8339 9.97873 34.9184 9.68377 34.7868C4.52118 32.4826 1.38161 28.5346 0.250442 22.9453C0.116177 22.2796 0.0862634 21.6019 0 20.9312C0 20.416 0 19.9009 0 19.3857Z",
    fill: "rgba(0, 0, 0, 0.38)",
    className: "bg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5091 0C20.4017 0.123158 21.2963 0.233647 22.1666 0.479962C27.4113 1.96067 31.0956 5.23455 33.2167 10.3115C33.3496 10.6288 33.2849 10.7506 32.9718 10.8674C28.1452 12.674 23.3221 14.4918 18.4983 16.3068C18.122 16.4482 18.0962 16.432 18.0962 16.0478C18.0955 10.8034 18.0955 5.55898 18.0962 0.314579C18.0962 0.20972 18.1115 0.105564 18.1199 0.000703757C18.5825 0.000703757 19.0458 0.000703757 19.5084 0.000703757L19.5091 0Z",
    fill: "rgba(0, 0, 0, 0.38)",
    className: "bg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7212 27.752C18.7219 23.1959 22.3624 19.5103 26.8585 19.5124C31.3345 19.5145 35.0285 23.2374 34.9993 27.7675C34.968 32.6065 31.0388 36.0246 26.8084 36C22.3819 35.974 18.6565 32.2574 18.7205 27.752H18.7212ZM23.1318 32.1406C23.3718 32.1294 23.5436 31.9555 23.7169 31.7803C26.0884 29.3805 28.4607 26.9807 30.8315 24.5801C30.9213 24.4894 31.02 24.3993 31.0799 24.2895C31.2141 24.0425 31.2065 23.7898 31.011 23.5745C30.8239 23.3683 30.5804 23.3521 30.3404 23.4527C30.2284 23.4999 30.1317 23.5977 30.0426 23.6878C27.6363 26.1193 25.232 28.5522 22.8278 30.985C22.7297 31.0843 22.6337 31.1849 22.5774 31.3172C22.4153 31.6972 22.6949 32.1364 23.1318 32.1406ZM29.9584 29.0821C28.9281 29.0856 28.1358 29.8935 28.14 30.9358C28.1441 31.9393 29.0026 32.7902 29.9967 32.7754C30.9957 32.7606 31.786 31.9393 31.7867 30.9154C31.7874 29.8682 30.9999 29.0786 29.9584 29.0821ZM25.5451 24.6379C25.5555 23.5956 24.7917 22.7842 23.7871 22.7694C22.7339 22.7539 21.9088 23.5491 21.8949 24.5928C21.8824 25.5936 22.7262 26.4528 23.7266 26.4585C24.7249 26.4641 25.5347 25.6534 25.5451 24.6386V24.6379Z",
    fill: "url(#paint0_linear_38100_2871)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0241 11.9315C15.0241 14.2715 15.0241 16.6115 15.0241 18.9515C15.0241 19.4335 15.0207 19.4371 14.5601 19.3273C10.0494 18.2547 5.53933 17.1808 1.02928 16.1069C0.565962 15.9964 0.556222 15.9908 0.703009 15.5206C1.94479 11.5402 4.34973 8.49644 7.9227 6.4098C9.87476 5.26972 11.9889 4.62507 14.229 4.42521C15.2168 4.33724 15.0179 4.36539 15.0207 5.12263C15.0304 7.39225 15.0241 9.66186 15.0241 11.9315Z",
    fill: "rgba(0, 0, 0, 0.38)",
    className: "bg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6361 35.9859C14.2385 36.0106 12.8736 35.7924 11.5254 35.4328C11.229 35.354 11.1254 35.254 11.2374 34.9275C12.8354 30.2644 14.4236 25.5985 16.0062 20.9305C16.0897 20.6841 16.2525 20.5863 16.4661 20.5061C20.5309 18.9817 24.595 17.4546 28.6591 15.9288C29.1795 15.7332 29.704 15.5495 30.2195 15.3433C30.4352 15.2575 30.5284 15.3067 30.5966 15.5284C30.9493 16.6847 31.1496 17.8691 31.245 19.0725C31.2693 19.3787 31.206 19.4124 30.8999 19.2618C29.3416 18.494 27.6887 18.1956 25.9773 18.3681C23.3978 18.6285 21.2537 19.7735 19.6091 21.8179C18.1893 23.5829 17.4831 25.6252 17.5305 27.8899C17.5875 30.6184 18.6352 32.9267 20.6359 34.7762C20.9295 35.0471 20.9288 35.0696 20.542 35.1977C18.9482 35.7248 17.3162 36.0141 15.6347 35.9859H15.6361Z",
    fill: "rgba(0, 0, 0, 0.38)",
    className: "bg"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38100_2871",
    x1: 34.9995,
    y1: 27.7563,
    x2: 18.7197,
    y2: 27.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#14B600",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E49",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38100_2871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.d3a02337c2fdc1c838303b03812537f1.svg";
export { ForwardRef as ReactComponent };